import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import PostPoll from './components/PostPoll';
export default () => {
  extend(CommentPost.prototype, 'content', function (content) {
    const post = this.attrs.post;
    if ((!post.isHidden() || this.revealContent) && post.polls()) {
      for (const poll of post.polls()) {
        if (poll) {
          content.push(m(PostPoll, {
            post: post,
            poll: poll
          }));
        }
      }
    }
  });
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => {
      var _polls$map;
      const polls = this.attrs.post.polls();
      const checks = polls == null || (_polls$map = polls.map) == null ? void 0 : _polls$map.call(polls, poll => {
        var _poll$data, _poll$options$map, _poll$options, _poll$myVotes$map, _poll$myVotes;
        return poll && [(_poll$data = poll.data) == null ? void 0 : _poll$data.attributes, (_poll$options$map = (_poll$options = poll.options()).map) == null ? void 0 : _poll$options$map.call(_poll$options, option => {
          var _option$data;
          return option == null || (_option$data = option.data) == null ? void 0 : _option$data.attributes;
        }), (_poll$myVotes$map = (_poll$myVotes = poll.myVotes()).map) == null ? void 0 : _poll$myVotes$map.call(_poll$myVotes, vote => {
          var _vote$option;
          return (_vote$option = vote.option()) == null ? void 0 : _vote$option.id();
        })];
      });
      return JSON.stringify(checks);
    });
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    // @ts-ignore
    if (app.pusher) {
      // @ts-ignore
      app.pusher.then(binding => {
        // We will listen for updates to all polls and options
        // Even if that model is not in the current discussion, it doesn't really matter
        binding.channels.main.bind('updatedPollOptions', data => {
          const poll = app.store.getById('polls', data['pollId']);
          if (poll) {
            poll.pushAttributes({
              voteCount: data['pollVoteCount']
            });

            // Not redrawing here, as the option below should trigger the redraw already
          }
          const changedOptions = data['options'];
          for (const optionId in changedOptions) {
            const option = app.store.getById('poll_options', optionId);
            if (option && option.voteCount() !== undefined) {
              option.pushAttributes({
                voteCount: changedOptions[optionId]
              });
            }
          }
          m.redraw();
        });
      });
    }
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    // @ts-ignore
    if (app.pusher) {
      // @ts-ignore
      app.pusher.then(binding => {
        binding.channels.main.unbind('updatedPollOptions');
      });
    }
  });
};